import { request } from "@/network/request.js";

// -产品单位-
// 添加单位
// name	是	string	名称
// sort	是	int	排序
export function add_goods_unit(params) {
	return request({
		url: '/hkt/goodsunit/add_goods_unit',
		params,
	})
}

// 删除单位
// unit_ids	是	int	单位id
export function del_goods_unit(unit_ids) {
	return request({
		url: '/hkt/goodsunit/del_goods_unit',
		params: {
			unit_ids,
		},
	})
}

// 修改单位
// unit_id	是	int	单位id
// name	是	string	名称
// sort	是	int	排序
export function edit_goods_unit(params) {
	return request({
		url: '/hkt/goodsunit/edit_goods_unit',
		params,
	})
}
// 单位列表
export function get_goods_unit_list(params) {
	return request({
		url: '/hkt/goodsunit/get_goods_unit_list',
		params,
	})
}

// -产品属性-=======================
// 添加属性
// name	是	string	名称
// sort	是	int	排序
export function add_goods_attribute(params) {
	return request({
		url: '/hkt/goodsattribute/add_goods_attribute',
		params,
	})
}

// 删除属性
// attrib_ids	是	int	属性id
export function del_goods_attribute(attrib_ids) {
	return request({
		url: '/hkt/goodsattribute/del_goods_attribute',
		params: {
			attrib_ids,
		},
	})
}


// 修改属性
// attrib_id	是	int	属性id
// name	是	string	名称
// sort	是	int	排序
export function edit_goods_attribute(params) {
	return request({
		url: '/hkt/goodsattribute/edit_goods_attribute',
		params,
	})
}

// 属性列表
export function get_goods_attribute_list(params) {
	return request({
		url: '/hkt/goodsattribute/get_goods_attribute_list',
		params,
	})
}